exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ivu-menu-item-selected .route-link{color:#2b85e4}.ivu-menu-vertical .ivu-menu-item{padding:6px 24px 6px 24px}.route-link{color:#495060;display:inline-block;width:100%;position:relative}.route-link:hover{text-decoration:underline}.style_dropdownbox{max-height:280px}.style_dropdownbox .ivu-select-item{padding:0}.style_dropdownbox .system_link{display:inline-block;padding:7px 16px;width:100%;color:#515a6e}.style_dropdownbox .system_link:hover{color:#2b85e4;text-decoration:underline}.product-sku-await-number{padding:1px 4px;margin-left:5px;background:#f20;border-radius:100%;color:#fff;font-size:12px}", ""]);

// exports
